import { UIColor } from "uicore-ts"
import { CBTableRowView } from "../CBTableRowView"
import { CellView } from "../CellView"
import { BSColor } from "./BSColor"

/**
 * RHTableRowView
 * Styles: Bootstrap .table .table-hover
 */
export class RHTableRowView<DataType> extends CBTableRowView<DataType> {
    
    constructor(elementID: string) {
        
        super(elementID);
        
        (this as RHTableRowView<DataType>).configureWithObject({
            padding: 0,
            controlEventTargetAccumulator: {
                PointerEnter: () => {
                    this.backgroundView.backgroundColor = BSColor.backgroundLight
                },
                PointerLeave: () => {
                    this.backgroundView.backgroundColor = UIColor.transparentColor
                }
            }
        })
        
        this.backgroundView.configureWithObject({
            style: {
                borderBottom: `1px solid ${BSColor.borderLight.stringValue}`
            }
        })
        
    }
    
    
    override set data(data: DataType[]) {
        super.data = data
        
        const cellStyle = {
            // padding: "0.5rem 0.5rem",
            borderRight: "none",
            borderLeft: "none",
            // fontSize: "1rem"
        }
        
        this.dataCells.forEach((cell: CellView) => {
            cell.configureWithObject({
                titleLabel: {
                    textColor: BSColor.dark,
                    style: { fontSize: "1rem" }
                },
                style: cellStyle
            })
        })
        
        if (this.rightCell) {
            this.rightCell.configureWithObject({ style: cellStyle })
        }
    }
    
    override get data() {
        return super.data
    }
    
}
